(function(){
    'use strict';
    angular.module('app').controller('JobsController', JobsController);

    JobsController.$inject = [
        'ArchivesJobsTableService',
        'JobsTableService', 
        'JobsBatchTable', 
        'P2PJobsTableService', 
        '$routeParams', 
        '$location'
    ];

    function JobsController(ArchivesJobsTableService,JobsTableService, JobsBatchTable, P2PJobsTableService, $routeParams, $location){
        let vm = this;
        const {tab} = $routeParams;
        const tabs = ['jobs', 'p2p', 'batches','archives'];

        vm.jobsListData = new JobsTableService({
            filters: {
                is_archived:false,
                driverId: $routeParams.driverId,
            }
        }, true).tableData;
        vm.batchTable = new JobsBatchTable({
            filters: {
                is_archived:false,
                driverId: $routeParams.driverId
            }
        }, true).tableData;
        vm.p2pJobsListData = new P2PJobsTableService({
            filters: {
                is_archived:false,
                driverId: $routeParams.driverId
            }
        }, false, true).tableData;

        vm.archiveJobs = new ArchivesJobsTableService({
            filters: {
                is_archived:true,
                driverId: $routeParams.driverId
            }
        }).tableData

        vm.changeTab = changeTab;

        function changeTab(index) {
            let params = {
                tab: tabs[index]
            };
            if($routeParams.driverId != undefined) {
                params.driverId = $routeParams.driverId
            }
            $location.search(params)
        }

        switch(tab){
            case 'archives':
                vm.active = 3;
            break;
            case 'batches': 
                vm.active = 2;
            break;
            case 'p2p': 
                vm.active = 1;
            break;
            default: 
                vm.active = 0;
            break;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/jobs/JobsController.js